<template>
  <div class="animated fadeIn indicador-ventas-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <div slot="header">Indicador de Ventas</div>

            <b-form-group
              label="Período"
              label-for="periodo"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="indicadorSemestreNombre" 
                :options="semestres" 
                :state="periodoValido"
                class="mb-3 select-fecha select-fecha-mes"
                @blur.native="validate">
                <template slot="first">
                  <option :value="null">Seleccione un semestre</option>
                </template>
              </b-form-select>

              <b-form-select 
                v-model="indicadorAnio" 
                :options="anios" 
                :state="periodoValido"
                class="mb-3 select-fecha select-fecha-anio"
                @blur.native="validate">
                <template slot="first">
                  <option :value="null">Seleccione un año</option>
                </template>
              </b-form-select>

              <b-form-invalid-feedback id="periodoFeedback">
                {{ periodoInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Período Base"
              label-for="periodoBase"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="indicadorSemestreBaseNombre" 
                :options="semestres" 
                :state="periodoBaseValido"
                class="mb-3 select-fecha select-fecha-mes"
                @blur.native="validate">
                <template slot="first">
                  <option :value="null">Seleccione un semestre</option>
                </template>
              </b-form-select>

              <b-form-select 
                v-model="indicadorAnioBase" 
                :options="anios" 
                :state="periodoBaseValido"
                class="mb-3 select-fecha select-fecha-anio"
                @blur.native="validate">
                <template slot="first">
                  <option :value="null">Seleccione un año</option>
                </template>
              </b-form-select>

              <b-form-invalid-feedback id="periodoBaseFeedback">
                {{ periodoBaseInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Fecha Vigencia - Desde"
              label-for="fechaVigenciaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVigenciaDesde" 
                v-model="fechaVigenciaDesde" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Vigencia - Hasta"
              label-for="fechaVigenciaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVigenciaHasta"
                v-model="fechaVigenciaHasta" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Descripcion"
              label-for="descripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="descripcion"
                v-model.trim="$v.descripcion.$model" 
                :state="descripcionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-form>
          <b-card>
            <div slot="header">Valores del Indicador
              <i class="fa fa-undo link-action"
                  @click.prevent="calcularObjetivo">
                <span>Actualizar Objetivo</span>
              </i>
            </div>

            <b-row>
              <b-col cols="6" xl="6">  
                <b-form-group
                  label="Monto Base"
                  label-for="montoBase"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="montoBase" 
                    :value="montoBase | moneda" 
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Pje.Inflación"
                  label-for="pjeInflacion"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="pjeInflacion" 
                    :value="pjeInflacion | porcentaje" 
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Base Ajustada"
                  label-for="montoBaseAjustado"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="montoBaseAjustado" 
                    :value="montoBaseAjustado | moneda" 
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Pje.Objetivo"
                  label-for="pjeObjetivo"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="pjeObjetivo"
                    v-model.trim="$v.pjeObjetivo.$model" 
                    :state="pjeObjetivoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeObjetivoFeedback">
                    {{ pjeObjetivoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Monto Objetivo"
                  label-for="montoObjetivo"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="montoObjetivo" 
                    v-model.trim="$v.montoObjetivo.$model" 
                    :state="montoObjetivoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="montoObjetivoFeedback">
                    {{ montoObjetivoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label=""
                  label-for="montoObjetivoReadonly"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="montoObjetivoReadonly" 
                    :value="montoObjetivo | moneda" 
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="6" xl="6">  
                <b-form-group
                  label="Base S/Reemb."
                  label-for="montoBaseSinReembolsos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="montoBaseSinReembolsos" 
                    :value="montoBaseSinReembolsos | moneda" 
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Pje.Inflación"
                  label-for="pjeInflacion"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="pjeInflacion" 
                    :value="pjeInflacion | porcentaje" 
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Ajustada S/Reemb."
                  label-for="montoBaseAjustadoSinReembolsos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="montoBaseAjustadoSinReembolsos" 
                    :value="montoBaseAjustadoSinReembolsos | moneda" 
                    readonly>
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Pje.Objetivo"
                  label-for="pjeObjetivoSinReembolsos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="pjeObjetivoSinReembolsos"
                    v-model.trim="$v.pjeObjetivoSinReembolsos.$model" 
                    :state="pjeObjetivoSinReembolsosValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="pjeObjetivoSinReembolsosFeedback">
                    {{ pjeObjetivoSinReembolsosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Objetivo S/Reemb."
                  label-for="montoObjetivoSinReembolsos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="montoObjetivoSinReembolsos" 
                    v-model.trim="$v.montoObjetivoSinReembolsos.$model" 
                    :state="montoObjetivoSinReembolsosValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="montoObjetivoSinReembolsosFeedback">
                    {{ montoObjetivoSinReembolsosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label=""
                  label-for="montoObjetivoSinReembolsosReadonly"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="montoObjetivoSinReembolsosReadonly" 
                    :value="montoObjetivoSinReembolsos | moneda" 
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card>
          <template slot="header">
            Clientes
            <i class="fa fa-plus link-action"
              @click.prevent="agregarCliente">
              <span>Agregar Cliente</span>
            </i>
          </template>  

          <b-table 
              class="registro clientes"
              responsive="sm" 
              :items="clientes" 
              :fields="clientesFields">
            <template v-slot:cell(pjeParticipacion)="data">
              {{ data.item.pjeParticipacion | porcentaje }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="removeCliente(data.item)">
                  <i class="fa fa-remove"></i>Borrar Cliente</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Objetivos Mensuales">
          <b-table 
              class="registro objetivos-mensuales"
              responsive="sm" 
              :items="objetivosMensuales" 
              :fields="objetivosMensualesFields">
            <template v-slot:cell(pjeObjetivo)="data">
              <input
                type="number" 
                step="0.01"
                v-model="data.item.pjeObjetivo"
                @focus="$event.target.select()"/>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="12">
        <b-card header="Historial del Indicador - Total">
          <app-historico-total
            ref="historicoTotal"
            :totalNegocio="true"
            :showTitulo="false">
          </app-historico-total>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="12">
        <b-card header="Historial del Indicador - Sin Reembolsos">
          <app-historico
            ref="historico"
            :totalNegocio="false"
            :showTitulo="false">
          </app-historico>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="clienteModal" 
        title="Parametros del Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cliente
        @actualizarCliente="actualizarCliente"
        @cancelar="cancelarActualizacionCliente">
      </app-cliente>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Cliente from './Cliente.vue'
import HistoricoTotal from '../dashboard/IndicadoresHistoricoVentas.vue';
import Historico from '../dashboard/IndicadoresHistoricoVentas.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, decimal, maxLength, minValue } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'indicadorVentas/getField',
  mutationType: 'indicadorVentas/updateField',
});

export default {
  name: 'IndicadorVentasABM',
  components: {
    appCliente: Cliente,
    appABMButton: ABMButtons,
    appData: Data,
    appMensaje: Mensaje,
    appConfirm: Confirm,
    appHistoricoTotal: HistoricoTotal,
    appHistorico: Historico,
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data () {
    return {
      noValidar: true,
      periodoValido: null,
      periodoInvalidoMsj: '',
      periodoBaseValido: null,
      periodoBaseInvalidoMsj: '',
      pjeObjetivoValido: null,
      pjeObjetivoInvalidoMsj: '',
      pjeObjetivoSinReembolsosValido: null,
      pjeObjetivoSinReembolsosInvalidoMsj: '',
      montoObjetivoValido: null,
      montoObjetivoInvalidoMsj: '',
      montoObjetivoSinReembolsosValido: null,
      montoObjetivoSinReembolsosInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',

      semestres: [],
      anios: [],

      clientesFields: [
        { 
          key: 'cliente',
        },
        { 
          key: 'pjeParticipacion',
          class: 'text-right',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      objetivosMensualesFields: [
        { 
          key: 'mesNombre',
          label: 'Mes'
        },
        { 
          key: 'pjeObjetivo',
          class: 'text-right',
        },
      ],

      labelCols: 2,
      inicializandoIndicador: false,
      actualizandoPorcentajes: false,
      actualizandoMontos: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaVigenciaDesde',
      'fechaVigenciaHasta',
      'indicadorSemestre',
      'indicadorSemestreNombre',
      'indicadorAnio',
      'indicadorSemestreBase',
      'indicadorSemestreBaseNombre',
      'indicadorAnioBase',
      'descripcion',
      'clientes',
      'discriminaObjetivosMensuales',
      'objetivosMensuales',
      
      'pjeInflacion',
      'montoBase',
      'montoBaseAjustado',
      'pjeObjetivo',
      'montoObjetivo',
      'montoBaseSinReembolsos',
      'montoBaseAjustadoSinReembolsos',
      'pjeObjetivoSinReembolsos',
      'montoObjetivoSinReembolsos',
    ]),
  },
  created() {
    let indicadorId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        indicadorId = this.$route.params.id;
      }
    }

    this.semestres = ['1er Semestre', '2do Semestre'];
    this.anios = this.getAniosPeriodo();

    this.showSpinner();
    this.inicializandoIndicador = true;
    this.$store.dispatch('indicadorVentas/inicializar', indicadorId)
      .then(() => {
        this.inicializandoIndicador = false;
        this.$refs.historicoTotal.getIndicadores();
        this.$refs.historico.getIndicadores();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());    
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pjeObjetivo' || validarTodos) {
        if (this.$v.pjeObjetivo.$error) {
          this.pjeObjetivoValido = false;
          if (!this.$v.pjeObjetivo.decimal) {
            this.pjeObjetivoInvalidoMsj = 'El porcentaje debe ser un valor numérico';
          } else {
            if (!this.$v.pjeObjetivo.minValue) {
              this.pjeObjetivoInvalidoMsj = 'El porcentaje ingresado no es válido';
            }      
          }     
        } else {
          this.pjeObjetivoValido = null;
          this.pjeObjetivoInvalidoMsj = '';
        }
      }

      if (campo == 'pjeObjetivoSinReembolsos' || validarTodos) {
        if (this.$v.pjeObjetivoSinReembolsos.$error) {
          this.pjeObjetivoSinReembolsosValido = false;
          if (!this.$v.pjeObjetivoSinReembolsos.decimal) {
            this.pjeObjetivoSinReembolsosInvalidoMsj = 'El porcentaje debe ser un valor numérico';
          } else {
            if (!this.$v.pjeObjetivoSinReembolsos.minValue) {
              this.pjeObjetivoSinReembolsosInvalidoMsj = 'El porcentaje ingresado no es válido';
            }      
          }     
        } else {
          this.pjeObjetivoSinReembolsosValido = null;
          this.pjeObjetivoSinReembolsosInvalidoMsj = '';
        }
      }

      if (campo == 'montoObjetivo' || validarTodos) {
        if (this.$v.montoObjetivo.$error) {
          this.montoObjetivoValido = false;
          if (!this.$v.montoObjetivo.decimal) {
            this.montoObjetivoInvalidoMsj = 'El monto debe ser un valor numérico';
          } else {
            if (!this.$v.montoObjetivo.minValue) {
              this.montoObjetivoInvalidoMsj = 'El monto ingresado no es válido';
            }
          }     
        } else {
          this.montoObjetivoValido = null;
          this.montoObjetivoInvalidoMsj = '';
        }
      }

      if (campo == 'montoObjetivoSinReembolsos' || validarTodos) {
        if (this.$v.montoObjetivoSinReembolsos.$error) {
          this.montoObjetivoSinReembolsosValido = false;
          if (!this.$v.montoObjetivoSinReembolsos.decimal) {
            this.montoObjetivoSinReembolsosInvalidoMsj = 'El monto debe ser un valor numérico';
          } else {
            if (!this.$v.montoObjetivoSinReembolsos.minValue) {
              this.montoObjetivoSinReembolsosInvalidoMsj = 'El monto ingresado no es válido';
            }      
          }     
        } else {
          this.montoObjetivoSinReembolsosValido = null;
          this.montoObjetivoSinReembolsosInvalidoMsj = '';
        }
      }

      if (campo == "descripcion" || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripcion sólo pueden contener hasta 50 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      if (this.indicadorSemestreNombre == null || this.indicadorAnio == null) {
        this.periodoValido = false;
        this.periodoInvalidoMsj = 'Debe seleccionar el período correspondiente';
        save = false;
      }

      if (this.indicadorSemestreBaseNombre == null || this.indicadorAnioBase == null) {
        this.periodoBaseValido = false;
        this.periodoBaseInvalidoMsj = 'Debe seleccionar el período base correspondiente';
        save = false;
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('indicadorVentas/save')
            .then( () => this.showModalMsj ('La información del indicador se actualizó con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: 'IndicadoresVentas' });
    },
    calcularObjetivo() {
      this.showSpinner();
      this.$store.dispatch('indicadorVentas/calcularObjetivo')
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
    },

    agregarCliente() {
      this.$refs.clienteModal.show();
    },
    removeCliente(item) {
      this.showModalConfirm('¿Desea borrar el porcentaje de participación del cliente seleccionado?', 
        this.removeClienteSeleccionado.bind(this, item.clienteId), 'Si', null, 'No')
    },
    removeClienteSeleccionado(clienteId) {
      this.$store.dispatch('indicadorVentas/removeCliente', clienteId)
        .catch(error => this.showErrorMsj(error))
    },
    actualizarCliente(params) {
      // console.log(params)
      this.$refs.clienteModal.hide();
      this.$store.dispatch('indicadorVentas/addCliente', params)
        .catch(error => this.showErrorMsj(error))

    },
    cancelarActualizacionCliente() {
      this.$refs.clienteModal.hide();
    }
  },
  watch: {
    // 'indicadorSemestre' : function(newVal, oldVal) {
    //   if (!this.inicializandoIndicador) {
    //     if ( newVal != 0 && oldVal != 0) {
    //       this.$store.dispatch('indicadorVentas/inicializarObjetivo')
    //         .catch( error => this.showErrorMsj (error));
    //     }
    //   }
    // },
    'indicadorSemestreNombre' : function(newVal, oldVal) {
      if (!this.inicializandoIndicador) {
        if ( newVal != oldVal) {
          this.$store.dispatch('indicadorVentas/inicializarObjetivo')
            .then(() => {
              this.$store.dispatch('indicadorVentas/inicializarObjetivosMensuales');
            })
            .catch( error => this.showErrorMsj (error));
        }
      }
    },
    'indicadorAnio' : function(newVal, oldVal) {
      if (!this.inicializandoIndicador) {
        if ( newVal != 0 && oldVal != 0) {
          this.$store.dispatch('indicadorVentas/inicializarObjetivo')
            .catch( error => this.showErrorMsj (error));
        }
      }
    },
    // 'indicadorSemestreBase' : function(newVal, oldVal) {
    //   if (!this.inicializandoIndicador) {
    //     if ( newVal != 0 && oldVal != 0) {
    //       this.$store.dispatch('indicadorVentas/inicializarObjetivo')
    //         .catch( error => this.showErrorMsj (error));
    //     }
    //   }
    // },
    'indicadorSemestreBaseNombre' : function(newVal, oldVal) {
      if (!this.inicializandoIndicador) {
        if ( newVal != 0 && oldVal != 0) {
          this.$store.dispatch('indicadorVentas/inicializarObjetivo')
            .catch( error => this.showErrorMsj (error));
        }
      }
    },
    'indicadorAnioBase' : function(newVal, oldVal) {
      if (!this.inicializandoIndicador) {
        if ( newVal != 0 && oldVal != 0) {
          this.$store.dispatch('indicadorVentas/inicializarObjetivo')
            .catch( error => this.showErrorMsj (error));
        }
      }
    },
    'pjeObjetivo' : function(newVal, oldVal) {
      if (!this.inicializandoIndicador && !this.actualizandoPorcentajes) {
        if ( newVal != 0 && oldVal != 0) {
          this.actualizandoMontos = true;
          this.$store.dispatch('indicadorVentas/calcularMontoObjetivo')
            .then(() => this.actualizandoMontos = false)
            .catch( error => this.showErrorMsj (error));
        }
      }
    },
    'pjeObjetivoSinReembolsos' : function(newVal, oldVal) {
      if (!this.inicializandoIndicador && !this.actualizandoPorcentajes) {
        if ( newVal != 0 && oldVal != 0) {
          this.actualizandoMontos = true;
          this.$store.dispatch('indicadorVentas/calcularMontoObjetivoSinReembolsos')
            .then(() => this.actualizandoMontos = false)
            .catch( error => this.showErrorMsj (error));
        }
      }
    },
    'montoObjetivo' : function(newVal, oldVal) {
      if (!this.inicializandoIndicador && !this.actualizandoMontos) {
        if ( newVal != 0 && oldVal != 0) {
          this.actualizandoPorcentajes = true;
          this.$store.dispatch('indicadorVentas/calcularPjeObjetivo')
            .then(() => this.actualizandoPorcentajes = false)
            .catch( error => this.showErrorMsj (error));
        }
      }
    },
    'montoObjetivoSinReembolsos' : function(newVal, oldVal) {
      if (!this.inicializandoIndicador && !this.actualizandoMontos) {
        if ( newVal != 0 && oldVal != 0) {
          this.actualizandoPorcentajes = true;
          this.$store.dispatch('indicadorVentas/calcularPjeObjetivoSinReembolsos')
            .then(() => this.actualizandoPorcentajes = false)
            .catch( error => this.showErrorMsj (error));
        }
      }
    },        
  },   
  validations: {
    pjeObjetivo: { 
      decimal, 
      minValue: minValue(0) 
    },
    pjeObjetivoSinReembolsos: { 
      decimal, 
      minValue: minValue(0) 
    },
    montoObjetivo: { 
      decimal, 
      minValue: minValue(0) 
    },
    montoObjetivoSinReembolsos: { 
      decimal, 
      minValue: minValue(0) 
    },
    descripcion: {
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
  #descripcion {
    text-transform: none;
  }

  .indicador-ventas-abm .card-header i.link-action {
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    cursor: pointer;
    margin-left: 12px;
    top: 2px; 
  }
  .indicador-ventas-abm .card-header i.link-action:hover {
    color: #20a8d8;
  }
  .indicador-ventas-abm .card-header span {
    font-size: 11px;
    font-weight: 600;
    font-style: italic;
    top: -2px;
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    margin-left: 5px;
  }
  .indicador-ventas-abm .card-header i.link-action:hover span{
    color: #20a8d8;
  }

  .indicador-ventas-abm .registro.clientes td[aria-colindex="1"] {
    width: calc(80% - 50px);
  }
  .indicador-ventas-abm .registro.clientes td[aria-colindex="2"] {
    width: 20%;
  }
  .indicador-ventas-abm .registro.clientes td[aria-colindex="3"] {
    width: 50px;
  }

  .indicador-ventas-abm .registro.objetivos-mensuales td[aria-colindex="1"] {
    width: 80%;
  }
  .indicador-ventas-abm .registro.objetivos-mensuales td[aria-colindex="2"] {
    width: 20%;
  }
  .indicador-ventas-abm .registro.objetivos-mensuales td input {
    width: 70%;
    left: 5%;
    margin: 0; 
    text-align: right;
    appearance: textfield;
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    border: none;
    border-bottom: 1px solid rgba(32, 168, 216, 0.8);
  }
  .indicador-ventas-abm .registro.objetivos-mensuales td input[type=number]::-webkit-inner-spin-button, 
  .indicador-ventas-abm .registro.objetivos-mensuales td input[type=number]::-webkit-outer-spin-button { 
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }
</style>
